import { faSparkles } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Message } from "semantic-ui-react";

import useUserPreference from "../../../../../../hooks/use-user-preference";
import { useState } from "react";

export function NotifyTwoWayCommunicationPromoBanner(props: { hasCrm: boolean; isProductsQueryLoading: boolean }) {
  const { hasCrm, isProductsQueryLoading } = props;

  const {
    value: userHasDismissed,
    update,
    query: { isLoading: isUserPreferenceLoading },
  } = useUserPreference("notify.twoWayCommunicationPromoBanner");
  const [immediateDismiss, setImmediateDismiss] = useState(false);

  const isLoading = isProductsQueryLoading || isUserPreferenceLoading;

  if (userHasDismissed || isLoading || immediateDismiss || hasCrm) return null;

  return (
    <Message className='tw-flex tw-flex-col tw-justify-between tw-gap-2 sm:tw-flex-row' info>
      <div className='tw-flex tw-items-center tw-gap-6'>
        <FontAwesomeIcon icon={faSparkles} size='xl' />
        <div>
          <Message.Content>Get GORequest for better communication</Message.Content>
        </div>
      </div>
      <div className='tw-flex tw-justify-end tw-gap-1 sm:tw-justify-start'>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://www.gogovapps.com/sms-voice?utm_source=In-Product&utm_campaign=SMS-Voice'
        >
          <Button as={"div"} icon='external' className='button-ghost tw-whitespace-nowrap' content='More Info' />
        </a>
        <div>
          <Button
            className='button-ghost tw-whitespace-nowrap'
            content='Dismiss'
            onClick={() => {
              setImmediateDismiss(true);
              update(new Date().toISOString());
            }}
          />
        </div>
      </div>
    </Message>
  );
}
